import { Component, OnInit } from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {ModalReceiptDetailsComponent} from "../../../../resources/components/modals/modal-receipt-details/modal-receipt-details.component";

@Component({
  selector: 'ui-modals',
  templateUrl: './ui-modals.component.html'
})
export class UiModalsComponent implements OnInit {

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  open() {
    this.modalService.show(ModalReceiptDetailsComponent);
  }

}
